import { Action } from 'redux';
import {
    Campaign,
    Sender,
    Template,
    CampaignRecipient,
    TemplateType,
    CampaignSimpleStats,
} from '@dev/ee-api/ee-api-models';

import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';
import { usePilotPlanConfig } from '@/services/hooks/usePilotPlanConfig';

export enum CampaignCreatorActionTypes {
    SET_DEFAULT_CAMPAIGN = '@@campaigncreator/SET_DEFAULT_CAMPAIGN',
    SET_DEFAULT_TARGET = '@@campaigncreator/SET_DEFAULT_TARGET',
    LOAD_START = '@@campaigncreator/LOAD_START',
    LOAD_SUCCESS = '@@campaigncreator/LOAD_SUCCESS',
    LOAD_ERROR = '@@campaigncreator/LOAD_ERROR',
    SAVE_START = '@@campaigncreator/SAVE_START',
    SAVE_SUCCESS = '@@campaigncreator/SAVE_SUCCESS',
    SAVE_ERROR = '@@campaigncreator/SAVE_ERROR',
    MODIFY_CAMPAIGN = '@@campaigncreator/MODIFY_CAMPAIGN',
    MODIFY_CAMPAIGN_MAP = '@@campaigncreator/MODIFY_CAMPAIGN_MAP',
    MODIFY_CAMPAIGN_SEND_TEST = '@@campaigncreator/MODIFY_CAMPAIGN_SEND_TEST',
    CLEAR_PICKED_CAMAPAIGN = '@@campaigncreator/CLEAR_PICKED_CAMAPAIGN',
    VERIFY_CAMPAIGN = '@@campaigncreator/VERIFY_CAMPAIGN',
    COUNT_RECIPIENTS_START = '@@campaigncreator/COUNT_RECIPIENTS_START',
    COUNT_RECIPIENTS_SUCCESS = '@@campaigncreator/COUNT_RECIPIENTS_SUCCESS',
    COUNT_RECIPIENTS_ERROR = '@@campaigncreator/COUNT_RECIPIENTS_ERROR',
    SET_CAMPAIGN_ERRORS = '@@campaigncreator/SET_CAMPAIGN_ERRORS',
    SET_CAMPAIGN_ERRORS_SUBSCRIBER = '@@campaigncreator/SET_CAMPAIGN_ERRORS_SUBSCRIBER',
    SELECT_TEMPLATE = '@@campaigncreator/SELECT_TEMPLATE',
    DESELECT_TEMPLATE = '@@campaigncreator/DESELECT_TEMPLATE',
    SET_ACTIVE_TEMPLATE_INDEX = '@@campaigncreator/SET_ACTIVE_TEMPLATE_INDEX',
    SET_ACTIVE_UTM_TAB_INDEX = '@@campaigncreator/SET_ACTIVE_UTM_TAB_INDEX',
    LOAD_TEMPLATE_START = '@@campaigncreator/LOAD_TEMPLATE_START',
    LOAD_TEMPLATE_SUCCESS = '@@campaigncreator/LOAD_TEMPLATE_SUCCESS',
    LOAD_TEMPLATE_ERROR = '@@campaigncreator/LOAD_TEMPLATE_ERROR',
    OPEN_GALLERY = '@@campaigncreator/OPEN_GALLERY',
    CLOSE_GALLERY = '@@campaigncreator/CLOSE_GALLERY',
    OPEN_EDITOR_DRAG_AND_DROP = '@@campaigncreator/OPEN_EDITOR_DRAG_AND_DROP',
    CLOSE_EDITOR_DRAG_AND_DROP = '@@campaigncreator/CLOSE_EDITOR_DRAG_AND_DROP',
    OPEN_TEMPLATE_EDITOR = '@@campaigncreator/OPEN_TEMPLATE_EDITOR',
    CLOSE_TEMPLATE_EDITOR = '@@campaigncreator/CLOSE_TEMPLATE_EDITOR',
    ADD_ATTACHMENT = '@@campaigncreator/ADD_ATTACHMENT',
    REMOVE_ATTACHMENT = '@@campaigncreator/REMOVE_ATTACHMENT',
    SET_FRIST_ERROR_FOCUSED = '@@campaigncreator/SET_FRIST_ERROR_FOCUSED',
    LOAD_COMPLETED_CAMPAIGNS_COUNT_START = '@@campaigncreator/LOAD_COMPLETED_CAMPAIGNS_COUNT_START',
    LOAD_COMPLETED_CAMPAIGNS_COUNT_SUCCESS = '@@campaigncreator/LOAD_COMPLETED_CAMPAIGNS_COUNT_SUCCESS',
    LOAD_COMPLETED_CAMPAIGNS_COUNT_ERROR = '@@campaigncreator/LOAD_COMPLETED_CAMPAIGNS_COUNT_ERROR',
    CHECK_ENTERED_DOMAIN_START = '@@campaigncreator/CHECK_ENTERED_DOMAIN_START',
    CHECK_ENTERED_DOMAIN_SUCCESS = '@@campaigncreator/CHECK_ENTERED_DOMAIN_SUCCESS',
    CHECK_ENTERED_DOMAIN_ERROR = '@@campaigncreator/CHECK_ENTERED_DOMAIN_ERROR',
    SEND_TEST = '@@campaigncreator/SEND_TEST',
    CONTINUE_WITH_HTML_TEMPLATE = '@@campaigncreator/CONTINUE_WITH_HTML_TEMPLATE',
    EDIT_CAMPAIGN_TEMPLATE = '@@campaigncreator/EDIT_CAMPAIGN_TEMPLATE',
    SET_AB_TABS = '@@campaigncreator/SET_AB_TABS',
    SET_AB_TABS_ERROR = '@@campaigncreator/SET_AB_TABS_ERROR',
    START_REMOVE_AB_TABS = '@@campaigncreator/START_REMOVE_AB_TABS',
    REMOVE_AB_TABS = '@@campaigncreator/REMOVE_AB_TABS',
    SAVE_IN_MY_TEMPLATES = '@@campaigncreator/SAVE_IN_MY_TEMPLATES',
    OPEN_PREVIEW_OVERLAY = '@@campaigncreator/OPEN_PREVIEW_OVERLAY',
    CLOSE_PREVIEW_OVERLAY = '@@campaigncreator/CLOSE_PREVIEW_OVERLAY',
    SWITCH_UTM = '@@campaigncreator/SWITCH_UTM',
    SET_SELECTED_TEMPLATES = '@@campaigncreator/SET_SELECTED_TEMPLATES',
    ADD_NEW_CAMPAIGN_TEMPLATE = '@@campaigncreator/ADD_NEW_CAMPAIGN_TEMPLATE',
    LOAD_CAMPAIGN_SIMPLE_STATS_START = '@@campaigncreator/LOAD_CAMPAIGN_SIMPLE_STATS_START',
    LOAD_CAMPAIGN_SIMPLE_STATS_SUCCESS = '@@campaigncreator/LOAD_CAMPAIGN_SIMPLE_STATS_SUCCESS',
    LOAD_CAMPAIGN_SIMPLE_STATS_ERROR = '@@campaigncreator/LOAD_CAMPAIGN_SIMPLE_STATS_ERROR',
    SET_AB_RECIPIENTS = '@@campaigncreator/SET_AB_RECIPIENTS',
    SET_RECALC_AB_RECIPIENTS = '@@campaigncreator/SET_RECALC_AB_RECIPIENTS',
    LOAD_ATTACHMENT_START = '@@campaigncreator/LOAD_ATTACHMENT_START',
    LOAD_ATTACHMENT_FINISH = '@@campaigncreator/LOAD_ATTACHMENT_FINISH',
    RESHARD_VALIDATION_FAILED = '@@campaigncreator/RESHARD_VALIDATION_FAILED',
}

export enum CampaignBackendErrors {
    NAME_ALREADY_EXISTS = 'Campaign name already exists',
    TEMPLATE_SIZE_EXCEEDS_LIMIT_SEND_TEST = 'Allowed email body size limit exceeded (maximum size is {{0}} MB)',
    TEMPLATE_SIZE_EXCEEDS_LIMIT_SEND_CAMPAIGN = 'email_size_limit_exceeded',
    TEMPLATE_NAME_IN_USE = 'Template name already in use, please use a unique name to add this template.',
    FROM_EMAIL_NOT_ASSOCIATED = 'from_not_associated_with_account',
    REPLY_TO_NOT_ASSOCIATED = 'replyto_not_associated_with_account',
    CAMPAIGN_RESHARD_REQUIRED_ERROR_MSG = 'campaign_reshard_required',
}

export const emailLimitBackendErrors = [
    'You have used all your free daily email credits. Upgrade your account to an unlimited billing plan to continue sending email.',
    'You can not send above your plan limit. Upgrade your account to a higher tier to continue sending emails.',
    'Error: Daily limit exceeded.',
    'Your plan expired. Renew your account\u0027s plan to continue sending email.',
];

export enum CampaignErrorNames {
    IS_DRAFT = 'IsDraft',
    TARGETS = `Targets`,
    SUBJECT_AND_CONTENT = `SubjectAndContent`,
    CAMPAIGN_TEMPLATES_BODY_SUBJECT = `CampaignTemplates[{{0}}].Body.Subject`,
    CAMPAIGN_TEMPLATES_UTM_SOURCE = `CampaignTemplates[{{0}}].UTM.UtmSource`,
    CAMPAIGN_TEMPLATES_UTM_MEDIUM = `CampaignTemplates[{{0}}].UTM.UtmMedium`,
    CAMPAIGN_TEMPLATES_UTM_CAMPAIGN = `CampaignTemplates[{{0}}].UTM.UtmCampaign`,
    CAMPAIGN_TEMPLATES_UTM_CONTENT = `CampaignTemplates[{{0}}].UTM.UtmContent`,
    SETTING_AND_TRACKING = `SettingAndTracking`,
    NAME = `Name`,
    SHORTNAME = 'ShortName',
    FROM_EMAIL = `CampaignTemplates[{{0}}].Sender.From[0]`,
    REPLY_TO_EMAIL = `CampaignTemplates[{{0}}].Sender.ReplyTo[0]`,
    OUT_OF_RECIPIENTS_LIMIT = 'OutOfRecipientsLimit',
    NO_TARGETS_SELECTED = 'NoTargetsSelected',
    NO_RECIPIENTS = 'NoRecipients',
    NOT_ENOUGH_RECIPIENTS = 'NotEnoughRecipients',
    TEMPLATE_SIZE = `CampaignTemplatesSize[{{0}}]`,
    NO_EMAIL_CREDITS = 'NoEmailCredits',
    SEND_TEST_TEMPLATE_SIZE = 'EmailExceedsAllowedSizeLimit',
    SEND_TEST_INVALID_EMAILS = 'SendTestEmailsInvalid',
    SEND_TEST_INVALID_EMAILS_STATUS = 'SendTestEmailsStatusInvalid',
    TEMPLATE_NAME_IN_USE = 'TemplateNameInUse',
    NO_EMAIL_TEMPLATE = 'NoEmailTemplate[{{0}}]',
    FROM_EMAIL_NOT_ASSOCIATED = 'FromEmailNotAssociated[{{0}}]',
    REPLY_TO_NOT_ASSOCIATED = 'ReplyToNotAssociated[{{0}}]',
    WINNER_SELECTION_UNIT = 'WinnerSelectionUnit',
}

export type CampaignErrorSubscriber = {
    id: string;
    errorName: string;
    order: number;
};

export type AbTabsType = {
    body: JSX.Element;
    id: string;
    onDelete?(id: number): void;
    tabTitle: string;
    title: string;
    hasError?: boolean;
};

export type AbRecipientsType = {
    uniqueRecipients: number;
    uniqueRecipientsPercent: number;
    isWinner?: boolean;
};

export type CampaignErrors = Record<string, boolean>;

export type TemplatesLoading = Record<number, string>;

export type EmailPartsType = {
    emailDomain: string;
    emailUsername: string;
};

export type SelectedTemplateType = {
    Sender?: Sender;
    Subject?: string;
    templateType?: TemplateType;
    isFromGallery?: boolean;
};

export type CampaignSendTest = {
    to?: string;
    fromName?: Sender;
    subject?: string;
    previewText?: string;
};

export type SaveInMyTemplatesType = {
    templateName: string;
    fromName: string;
    fromEmail: string;
    subject: string;
};

export type ContentBackendErrorsType = {
    [key: string]: number[];
};

export type SaveCampaignParams = {
    isDraft: boolean;
    openDomainValidationScreen?: boolean;
    redirectURL?: string;
};

export interface SetDefaultCampaignAction extends Action {
    type: CampaignCreatorActionTypes.SET_DEFAULT_CAMPAIGN;
    payload: {
        isTestingCompleted: boolean;
        isAccountTrusted: boolean;
        defaultSenderEmail: string;
        defaultSenderName: string;
        isAbCampaign?: boolean;
        pilotPlanCampaign?: ReturnType<typeof usePilotPlanConfig>['pilotDefaultCampaignOverride'];
    };
}

export interface SetDefaultTargetAction extends Action {
    type: CampaignCreatorActionTypes.SET_DEFAULT_TARGET;
    payload: {
        targets: CampaignRecipient;
    };
}

export interface ModifyCampaignMapAction extends Action {
    type: CampaignCreatorActionTypes.MODIFY_CAMPAIGN_MAP;
    payload: Map<string, any>;
}

export interface ModifyCampaignSendTestAction extends Action {
    type: CampaignCreatorActionTypes.MODIFY_CAMPAIGN_SEND_TEST;
    payload: {
        objectPath: string;
        value: any;
    };
}

export interface LoadCampaignStartAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_START;
    payload: {
        name: string;
    };
}

export interface LoadCampaignSuccessAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_SUCCESS;
    payload: Campaign;
}

export interface LoadCampaignErrorAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_ERROR;
}

export interface SaveCampaignStartAction extends Action {
    type: CampaignCreatorActionTypes.SAVE_START;
    payload: SaveCampaignParams;
    meta: {
        thunk: boolean;
    };
}

export interface SetAbRecipientsAction extends Action {
    type: CampaignCreatorActionTypes.SET_AB_RECIPIENTS;
}

export interface SetRecalcAbRecipientsAction extends Action {
    type: CampaignCreatorActionTypes.SET_RECALC_AB_RECIPIENTS;
    payload: {
        abRecipients: AbRecipientsType[];
    };
}

export interface SetAbTabsAction extends Action {
    type: CampaignCreatorActionTypes.SET_AB_TABS;
    payload: {
        abTabs: AbTabsType[];
    };
}

export interface StartRemoveAbTabsAction extends Action {
    type: CampaignCreatorActionTypes.START_REMOVE_AB_TABS;
    payload: {
        id: number;
    };
}

export interface RemoveAbTabsAction extends Action {
    type: CampaignCreatorActionTypes.REMOVE_AB_TABS;
    payload: {
        id: number;
    };
}

export interface SetAbTabsErrorAction extends Action {
    type: CampaignCreatorActionTypes.SET_AB_TABS_ERROR;
}

export interface SaveCampaignSuccessAction extends Action {
    type: CampaignCreatorActionTypes.SAVE_SUCCESS;
    meta: Record<string, unknown>;
}

export interface SaveCampaignErrorAction extends Action {
    type: CampaignCreatorActionTypes.SAVE_ERROR;
}
export interface VerifyCampaignAction extends Action {
    type: CampaignCreatorActionTypes.VERIFY_CAMPAIGN;
}

export interface CountRecipientsStartAction extends Action {
    type: CampaignCreatorActionTypes.COUNT_RECIPIENTS_START;
    payload: {
        isAllContactsSelected: boolean;
    };
}

export interface CountRecipientsSuccessAction extends Action {
    type: CampaignCreatorActionTypes.COUNT_RECIPIENTS_SUCCESS;
    payload: number;
}

export interface CountRecipientsErrorAction extends Action {
    type: CampaignCreatorActionTypes.COUNT_RECIPIENTS_ERROR;
}

export interface SetCampaignErrorsAction extends Action {
    type: CampaignCreatorActionTypes.SET_CAMPAIGN_ERRORS;
    payload: {
        errors: CampaignErrors;
        activeTabsIndexes?: {
            activeTemplateIndex?: number;
            activeUtmTabIndex?: number;
        };
    };
}

export interface SetCampaignErrorsSubscriberAction extends Action {
    type: CampaignCreatorActionTypes.SET_CAMPAIGN_ERRORS_SUBSCRIBER;
    payload: CampaignErrorSubscriber;
}

export interface SetFirstErrorFocusedAction extends Action {
    type: CampaignCreatorActionTypes.SET_FRIST_ERROR_FOCUSED;
}
export interface SelectTemplateAction extends Action {
    type: CampaignCreatorActionTypes.SELECT_TEMPLATE;
    payload: {
        templateName: string;
        isPublic?: boolean;
        isFromGallery?: boolean;
    };
}

export interface OpenGalleryAction extends Action {
    type: CampaignCreatorActionTypes.OPEN_GALLERY;
}

export interface CloseGalleryAction extends Action {
    type: CampaignCreatorActionTypes.CLOSE_GALLERY;
}

export interface OpenEditorDragAndDropAction extends Action {
    type: CampaignCreatorActionTypes.OPEN_EDITOR_DRAG_AND_DROP;
    payload: {
        templateName?: string;
        isPublic?: boolean;
        isEditedFromGallery?: boolean;
    };
}

export interface CloseEditorDragAndDropAction extends Action {
    type: CampaignCreatorActionTypes.CLOSE_EDITOR_DRAG_AND_DROP;
}

export interface OpenTemplateEditorAction extends Action {
    type: CampaignCreatorActionTypes.OPEN_TEMPLATE_EDITOR;
    payload: {
        templateName?: string;
    };
}

export interface CloseTemplateEditorAction extends Action {
    type: CampaignCreatorActionTypes.CLOSE_TEMPLATE_EDITOR;
}

export interface ClearPickedCampaignAction extends Action {
    type: CampaignCreatorActionTypes.CLEAR_PICKED_CAMAPAIGN;
}

export interface LoadTemplateStartAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_TEMPLATE_START;
    payload: {
        templateName: string;
        index: number;
    };
}

export interface LoadTemplateSuccessAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_TEMPLATE_SUCCESS;
    payload: {
        template: Template;
        index: number;
        isFromGallery?: boolean;
    };
}

export interface LoadTemplateErrorAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_TEMPLATE_ERROR;
    payload: {
        index: number;
    };
}
export interface DeselectTemplateAction extends Action {
    type: CampaignCreatorActionTypes.DESELECT_TEMPLATE;
    payload: {
        index: number;
    };
}
export interface AddCampaignAttachmentAction extends Action {
    type: CampaignCreatorActionTypes.ADD_ATTACHMENT;
    payload: {
        file: File;
        templateIndex: number;
    };
}
export interface RemoveCampaignAttachmentAction extends Action {
    type: CampaignCreatorActionTypes.REMOVE_ATTACHMENT;
    payload: {
        fileName: string;
        templateIndex: number;
    };
}

export interface CheckEnteredDomainStartAction extends Action {
    type: CampaignCreatorActionTypes.CHECK_ENTERED_DOMAIN_START;
    payload: {
        email: string;
    };
}

export interface CheckEnteredDomainSuccessAction extends Action {
    type: CampaignCreatorActionTypes.CHECK_ENTERED_DOMAIN_SUCCESS;
    payload: {
        isFreeDomain: boolean;
    };
}

export interface CheckEnteredDomainErrorAction extends Action {
    type: CampaignCreatorActionTypes.CHECK_ENTERED_DOMAIN_ERROR;
}

export interface SetActiveTemplateIndexAction extends Action {
    type: CampaignCreatorActionTypes.SET_ACTIVE_TEMPLATE_INDEX;
    payload: number;
}

export interface SetActiveUtmTabIndexAction extends Action {
    type: CampaignCreatorActionTypes.SET_ACTIVE_UTM_TAB_INDEX;
    payload: number;
}

export interface LoadCompletedCampaignsCountStartAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_COMPLETED_CAMPAIGNS_COUNT_START;
}

export interface LoadCompletedCampaignsCountSuccessAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_COMPLETED_CAMPAIGNS_COUNT_SUCCESS;
    payload: number;
}

export interface LoadCompletedCampaignsCountErrorAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_COMPLETED_CAMPAIGNS_COUNT_ERROR;
}

export interface SendTestAction extends Action {
    type: CampaignCreatorActionTypes.SEND_TEST;
}

export interface ContinueWithHTMLTemplateAction extends Action {
    type: CampaignCreatorActionTypes.CONTINUE_WITH_HTML_TEMPLATE;
}

export interface OpenPreviewOverlayAction extends Action {
    type: CampaignCreatorActionTypes.OPEN_PREVIEW_OVERLAY;
}

export interface ClosePreviewOverlayAction extends Action {
    type: CampaignCreatorActionTypes.CLOSE_PREVIEW_OVERLAY;
}

export interface SwitchUTMAction extends Action {
    type: CampaignCreatorActionTypes.SWITCH_UTM;
}
export interface EditCampaignTemplateAction extends Action {
    type: CampaignCreatorActionTypes.EDIT_CAMPAIGN_TEMPLATE;
    payload: {
        templateName?: string;
        templateType?: TemplateType;
        isPublic?: boolean;
        isEditedFromGallery?: boolean;
    };
}

export interface SaveInMyTemplatesAction extends Action {
    type: CampaignCreatorActionTypes.SAVE_IN_MY_TEMPLATES;
    payload: {
        params: SaveInMyTemplatesType;
    };
}

export interface SetSelectedTemplatesAction extends Action {
    type: CampaignCreatorActionTypes.SET_SELECTED_TEMPLATES;
    payload: {
        selectedTemplates: SelectedTemplateType[];
    };
}

export interface AddNewCampaignTemplateAction extends Action {
    type: CampaignCreatorActionTypes.ADD_NEW_CAMPAIGN_TEMPLATE;
    payload: {
        defaultSenderEmail: string;
        defaultSenderName: string;
    };
}

export interface LoadCampaignSimpleStatsStartAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_CAMPAIGN_SIMPLE_STATS_START;
    payload: {
        name: string;
        from: string;
    };
}

export interface LoadCampaignSimpleStatsSuccessAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_CAMPAIGN_SIMPLE_STATS_SUCCESS;
    payload: {
        campaignSimpleStats: CampaignSimpleStats;
    };
}

export interface LoadCampaignSimpleStatsErrorAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_CAMPAIGN_SIMPLE_STATS_ERROR;
}

export interface LoadAttachmentStartAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_ATTACHMENT_START;
}

export interface LoadAttachmentFinishAction extends Action {
    type: CampaignCreatorActionTypes.LOAD_ATTACHMENT_FINISH;
}

export interface TimeDelayInterface {
    value: number;
    unit: TimeUnitsEnum;
}

export interface CampaignCreatorState {
    name?: string;
    campaign?: Campaign;
    loadedCampaign?: Campaign;
    defaultCampaign?: Campaign;
    recipientsCount: number;
    isRecipientsCountLoading: boolean;
    isNew: boolean;
    isSaved: boolean;
    isSaving: boolean;
    isLoading: boolean;
    isSuccess: boolean;
    errors?: CampaignErrors;
    firstErrorFocused: boolean;
    errorsSubscribers: CampaignErrorSubscriber[];
    isGalleryOpen?: boolean;
    editorDragAndDrop: {
        isOpen?: boolean;
        sourceTemplateName?: string;
        isPublic?: boolean;
        isEditedFromGallery?: boolean;
    };
    templatesLoading: TemplatesLoading;
    activeTemplateIndex: number;
    activeUtmTabIndex: number;
    selectedTemplate?: SelectedTemplateType[];
    completedCampaignsCount?: number;
    completedCampaignsLoading?: boolean;
    isFromEmailFree?: boolean;
    sendTestConfig?: CampaignSendTest;
    abTabs?: AbTabsType[];
    abRecipients?: AbRecipientsType[];
    isPreviewOverlayOpen?: boolean;
    campaignSimpleStats?: CampaignSimpleStats;
    campaignSimpleStatsLoading?: boolean;
    attachmentLoading?: boolean;
    templateEditor: {
        isOpen?: boolean;
        sourceTemplateName?: string;
    };
}
